import React from 'react';
import {Dialog, FlatButton, RaisedButton} from "material-ui";

export default (props) => {
  const { onConfirm, onDismiss, children, ...rest } = props;
  const actions = [
    <FlatButton
      label="Cancel"
      primary
      onClick={onDismiss}
    />,
    <RaisedButton
      label="Delete"
      secondary
      keyboardFocused
      onClick={onConfirm}
    />,
  ];

  return (
    <Dialog
      {...rest}
      actions={actions}
      modal={false}
    >
      {children}
    </Dialog>
  );
};



// WEBPACK FOOTER //
// ./src/components/DeleteDialog.js